import PropTypes from 'prop-types';
import { Box, Flex, Text } from '@qga/roo-ui/components';
import { PointsDisclaimer } from 'components/Disclaimers';
import { FormattedMoney } from 'components/Formatters';
import { NonWrappingText } from 'components/Typography';

const PointsItem = ({ description, points }) => (
  <Flex flexDirection="row" mt={[3, 0]}>
    <Box width="100%">
      <Text fontSize={['sm', 'lg']} data-testid="qff-points-description">
        {description} <PointsDisclaimer.Link />
      </Text>
    </Box>
    <Box textAlign={['right', 'left']} pl="5">
      <NonWrappingText fontSize="xl" fontWeight="bold" data-testid="qff-points-value">
        <FormattedMoney amount={points} currency="PTS" />
      </NonWrappingText>
    </Box>
  </Flex>
);

PointsItem.propTypes = {
  points: 0,
};

PointsItem.propTypes = {
  description: PropTypes.string,
  points: PropTypes.number,
};

export default PointsItem;
